import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const CheckOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth={3}
      transform="translate(4 4)"
    >
      <circle cx={12.5} cy={12.5} r={12.5} />
      <path d="M10.5 17.5l8-9M10.5 17.5l-4-4" />
    </g>
  </svg>
)
